import { orderBy } from "lodash";
import getDistanceToStore from "./getDistanceToStore";

export const getStoresByProximity = (
  allLululemonStores,
  location,
  countryCode,
  distanceFilter
) => {
  const storesWithinProximity = [];
  const unitsForDistance = countryCode === "US" ? "mile" : "kilometer";
  allLululemonStores?.forEach((store) => {
    const distanceToStore = getDistanceToStore(
      { latitude: store.latitude, longitude: store.longitude },
      { latitude: location.lat, longitude: location.lng },
      unitsForDistance
    );
    if (distanceToStore < distanceFilter && store.country === countryCode) {
      storesWithinProximity.push({
        ...store,
        distanceToStore,
      });
    }
  });
  return orderBy(storesWithinProximity, ["distanceToStore", "asc"]);
};
